<template>
  <section v-for="section in sections" :key="section.name" class="form-section" :aria-label="section.name">
    <div class="section-heading grid justify-items-start gap-2">
      <h2>{{ section.name }}</h2>
      <p v-if="section.description" class="text-subtle">{{ section.description }}</p>
    </div>
    <component :is="questions[question]" v-for="question in section.questions" :key="question" />
  </section>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

export type FormSection = {
  name: string
  description?: string
  questions: readonly string[]
}

defineProps<{
  sections: readonly FormSection[]
  questions: Record<string, Component>
}>()
</script>

<style scoped lang="scss">
.form-section {
  display: grid;
  gap: var(--space-12);
  padding-top: 28px;
  border-top: 1px solid var(--color-border-default);
}

.form-section:first-child {
  padding-top: 0;
  border-top: 0;
}
</style>
